module.exports = "/_next/static/images/30c7e244d3082c87045c9adec96dbdc4-boy-looking-to-the-front-xs@3x.jpg";